<template>
  <div>
    <div class="xinz">
      <div class="right">
        <el-button type="warning" @click="handleAdd" v-if="canAdd"><i class="fa fa-plus" />新增角色</el-button>
      </div>
    </div>
      <div>
        <el-form :inline="true"  class="demo-form-inline" size="small" @submit.native.prevent @keyup.native.enter="requestRoleList">
          <el-form-item label="搜索條件：">
            <el-input placeholder="角色名" v-model="searchName" clearable>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="requestRoleList"><i class="fa fa-search" />查詢</el-button>
          </el-form-item>
        </el-form>
      </div>
    <div>
      <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
              v-loading="roleTableloading"
              @selection-change="handleSelectionChange"
              :data="roles"
              empty-text="无数据"
              stripe
              border
              class="dataListTable">
        <el-table-column
                prop="name"
                align="left"
                label="角色">
        </el-table-column>
        <el-table-column
                prop="addBy"
                align="left"
                label="創建人">
        </el-table-column>
        <el-table-column
                prop="addTime"
                align="left"
                label="創建時間">
          <template  slot-scope="scope">
			 <!-- {{scope.row.addTime}} -->
      {{scope.row.addTime*1000 | date('%Y-%m-%d %T') }}
          </template>
        </el-table-column>
        <el-table-column
                prop="id"
                width="100"
                align="center"
                label="操作">
          <template slot-scope="scope">
            <template>
              <el-dropdown>
                <el-button size="small" type="primary">
                  <i class="fa fa-mouse-pointer"/>操作
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item  @click.native="handleEdit(scope.$index, scope.row)" v-if="canEdit"><i class="fa fa-edit"/> 編輯</el-dropdown-item>
                  <el-dropdown-item  @click.native="handleDelete(scope.$index, scope.row)" v-if="canDelete"><i class="fa fa-trash"/> 刪除</el-dropdown-item>
                  <el-dropdown-item  @click.native="handleAddByCopy(scope.$index, scope.row)" v-if="canAdd"><i class="fa fa-plus"/>複制</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
              layout="total, prev, pager, next"
              @current-change="handleCurrentChange"
              :current-page.sync="pager.page"
              :page-size="pager.size"
              :total="pager.total">
      </el-pagination>
    </div>
    <el-dialog :title="dialogName" :visible.sync="dialogRoleFormVisible" width="420px" :close-on-click-modal=false>
      <el-form :model="roleForm" :rules="roleRules" ref="roleForm" class="demo-ruleForm login-container" label-width="200px" size="small">
        <el-form-item label="角色名稱" prop="name" label-width="120px">
          <el-input v-model="roleForm.name"  placeholder="" auto-complete="off" style="width:200px"></el-input>
        </el-form-item>
        <el-form-item label="權限設置" prop="pids" label-width="120px">
          <el-tree
                  :data="permissionTreeData"
                  :props="permissionTreeProps"
                  show-checkbox
                  accordion
                  node-key="uid"
                  :default-expand-all="false"
                  ref="permissionTree"
                  :auto-expand-parent="true"
                  @check-change="handleCheckChange"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
                 <el-tooltip v-if="!data.children" class="item" effect="dark" :content="data.remark" placement="right">
                    <span>{{ node.label }}</span>
                 </el-tooltip>
                  <span v-else>{{ node.label }}</span>
               </span>
              <!-- <span class="custom-tree-node" slot-scope="{ node, data }">
                 <el-tooltip v-if="!data.children" class="item" effect="dark" :content="data.remark" placement="right">
                    <span>{{ node.label }}</span>
                 </el-tooltip>
                  <span v-else>{{ node.label }}</span>
               </span>-->
            <!--:default-expanded-keys="permissionTreeExpandedKeys"-->
          </el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogRoleFormVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave" :loading="roleSaveloading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import { getRoleList,getPermissionTree,insertRole,updateRole,deleteRole,getRoleById,addRoleByCopy,getStffRoles } from '../api/api'

    export default {
        data() {
            return {
                searchName:'',
                roles:[],
                selectionRoles:[],
                roleTableloading:false,
                roleSaveloading:false,
                pager:{
                    page:1,
                    size:10,
                    total:0
                },
                dialogName:'新增角色',
                dialogRoleFormVisible:false,
                roleForm:{
                    id:'',
                    name:'',
                    pids:[],
                    oids:[],
                    mids:[]
                },
                roleRules: {
                    name: [
                        {required: true, message: this.$t('m.m_accountnumber'), trigger: 'blur' },
                        { min: 2, max: 20, message:this.$t('m.m_length220'), trigger: 'blur' }
                    ],
                    pids: [
                        {required: false, message: this.$t('m.m_jurisdiction'), trigger: 'blur' },
                    ]
                },
                permissionTreeExpandedKeys:[],
                permissionTreeData: [],
                permissionTreeProps: {
                    children: 'children',
                    label: 'name'
                }
            }
        },
        methods: {
            requestRoleList(){
                this.roleTableloading=true;
                var params={page:this.pager.page,size:this.pager.size,name:this.searchName.trim()};
                return getRoleList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        let {size,page,total,data:roles=[]}=res.data;
                        this.roles=roles;
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.roleTableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            requestPermissionTree(){
                return getPermissionTree().then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        this.permissionTreeData=JSON.parse(res.data);
                        let  expandedKyes=[];
                        this.permissionTreeData.forEach((x,i)=>(expandedKyes[i]=x.id));
                        this.permissionTreeData.forEach((item,index)=>{
                            item.name=item.name;
                            if(item.id!=9){
                                item.children.forEach((chiItem,index)=>{
                                    chiItem.name=chiItem.name;
                                });
                            }
                        });
                        this.permissionTreeExpandedKeys=expandedKyes;
                        this.$refs.permissionTree.setCheckedKeys([]);
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            requestRoleById(id){
                return getRoleById(id).then(data=>{
                    let {data:res={}}=data;
                    let {id,name,pids=""}=res.data;
                    this.roleForm.id=id;
                    this.roleForm.name=name;
                    this.roleForm.pids=pids;
                    if(pids==null || pids==''){
                        let logicPids=[];
                        this.$refs.permissionTree.setCheckedKeys(logicPids);
                        this.permissionTreeExpandedKeys=logicPids;
                    }else{
                        let logicPids=pids.split(",");
                        this.$refs.permissionTree.setCheckedKeys(logicPids);
                        this.permissionTreeExpandedKeys=logicPids;
                    }
                });
            },
            requestDeleteRole(ids){
                this.$confirm(this.$t('m.m_deleterole'), this.$t('m.m_info'), {
                    confirmButtonText: this.$t('m.t_confirm'),
                    cancelButtonText: this.$t('m.t_cancel'),
                    type: 'warning'
                }).then(() => {
                   /* deleteRole(ids).then(data=>{
                        let {errcode,errmsg}=data.data;
                        if(errcode==200){
                            this.$message.success(this.$t('m.m_deletesuc'));
                            this.requestRoleList();
                        }else{
                            this.$message.error(errmsg);
                        }
                    });*/
                    return getStffRoles(ids).then(data=>{
                        if(data.data.data==0){
                            deleteRole(ids).then(data=>{
                                let {errcode,errmsg}=data.data;
                                if(errcode==200){
                                    this.$message.success(this.$t('m.m_deletesuc'));
                                    this.requestRoleList();
                                }else{
                                    this.$message.error("删除失败！");
                                }
                            });
                        }else {
                            this.$message.warning("還有員工是該角色，不能刪除！");
                        }
                    });
                })
            },
            handleCurrentChange(val){
                this.requestRoleList();
            },
            handleCheckChange(data, checked, indeterminate) {
                let nodes=this.$refs.permissionTree.getCheckedNodes();
                let oids=[];
                let mids=[];
                let pids=[];
                nodes.forEach(node=>{
                    if(node.type=="o"){
                        oids[oids.length]=node.id;
                        pids[pids.length]=node.uid;
                    }else if(node.type=="m"){
                        mids[mids.length]=node.id;
                        pids[pids.length]=node.uid;
                    }
                });
                this.roleForm.oids=oids.join(",");
                this.roleForm.mids=mids.join(",");

                this.roleForm.pids=pids.join(",");
                this.$refs.roleForm.validateField('pids');
            },
            handleSelectionChange(val){
                this.selectionRoles=val;
            },
            handleAdd(ev){
                this.roleForm={id:'', name:'',pids:[]};
                this.dialogName=this.$t('m.b_newrole'),
                    this.dialogRoleFormVisible=true;
                this.requestPermissionTree();
                this.resetForm("roleForm");
            },
            handleEdit(index,row){
                this.dialogName=this.$t('m.t_updaterole'),
                    this.dialogRoleFormVisible=true;
                this.requestPermissionTree().then(data=>{
                    this.requestRoleById(row.id);
                });
                this.resetForm("roleForm");
            },
            handleAddByCopy(index,row){
                this.$confirm("確定要復制新增 '"+row.name+"' 嗎？",{
                    confirmButtonClass:"Confirm",
                    cancelButtonClass:"Cancel",
                    closeOnClickModal:false,
                    type:"warning"
                }).then(()=>{
                    return addRoleByCopy(row.id).then(data=>{
                        if(data.data.errcode==200){
                            this.requestRoleList();
                        }else{
                            this.$message.error(data.data.errmsg);
                        }
                    });

                })
            },
            handleSave(ev){
                this.$refs.roleForm.validate((valid) => {
                    if (valid) {
                        if(this.roleForm.id==""){
                            this.roleSaveloading=true;
                            if(this.roleForm.pids==null){
                                this.roleForm.pids="";
                            }
                            if(this.roleForm.oids==null){
                                this.roleForm.oids="";
                            }
                            if(this.roleForm.mids==null){
                                this.roleForm.mids="";
                            }
                            var  params=Object.assign({},this.roleForm);
                            delete params.id;
                            insertRole(params).then(data=>{
                                this.roleSaveloading=false;
                                let {errcode,errmsg}=data.data;
                                if(errcode==200){
                                    this.$message.success(this.$t('m.m_newsucs'));
                                    this.requestRoleList();
                                    this.dialogRoleFormVisible=false;
                                    this.resetForm("roleForm");
                                }else{
                                    this.$message.error("新增失败！");
                                }
                            });
                        }else{
                            var params=Object.assign({},this.roleForm);
                            updateRole(params).then(data=>{
                                this.roleSaveloading=false;
                                let {errcode,errmsg}=data.data;
                                if(errcode==200){
                                    this.$message.success(this.$t('m.m_updatesucs'));
                                    this.requestRoleList();
                                    this.dialogRoleFormVisible=false;
                                    this.resetForm("roleForm");
                                }else{
                                    this.$message.error("修改失败！");
                                }
                            });
                        }
                    }
                });
            },
            handleDelete(index,row){
                this.requestDeleteRole(row.id);
            },
            handleBatchDelete(){
                var ids=[];
                this.selectionRoles.forEach((v,i)=>ids[i]=v.id);
                this.requestDeleteRole(ids.join(","));
            },
            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            },
        },
        mounted() {

        },
        computed: {
            canAdd(){
                return this.$store.getters.hasPermission("ROLE_ADD");
            },
            canEdit(){
                return this.$store.getters.hasPermission("ROLE_EDIT");
            },
            canDelete(){
                return this.$store.getters.hasPermission("ROLE_DELETE");
            }
        },
        activated(){
            this.requestRoleList();
        }
    }

</script>

<style lang="scss">
  .menu{
    .right{
      float: right;
    }
  }
  .dataListTable .cell{ white-space:nowrap; }
</style>



// WEBPACK FOOTER //
// src/views/Role.vue